<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="12">
        <v-text-field
          name="productName"
          outlined
          dense
          label="Item Code (optional)"
          v-model="record.ItemCode"
          type="text"
          autocomplete="off"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12">
        <v-text-field
          autocomplete="off"
          type="text"
          hide-details
          outlined
          dense
          label="Product Name"
          v-model="record.productName"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          autocomplete="off"
          type="text"
          hide-details
          outlined
          dense
          label="Description"
          v-model="record.Description"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="6" class="d-flex justify-center align-center">
        <v-radio-group
          style="margin-top: -5px"
          dense
          label="With Serial"
          v-model="record.SerialStatus"
          row
        >
          <v-radio label="No" value="N"></v-radio>
          <v-radio label="Yes" value="Y"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="6" v-show="record.SerialStatus == 'Y'">
        <v-text-field
          autocomplete="off"
          type="text"
          hide-details
          outlined
          dense
          label="Serial No"
          v-model="record.SerialNo"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="6">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.i_t_m1_s_id"
          :items="categories"
          label="Category"
          item-text="Name"
          item-value="id"
        >
          <template v-if="enableCreate" v-slot:no-data>
            <v-row align="center" justify="center">
              <v-btn
                :loading="searchingProduct"
                class="ma-2"
                color="accent"
                dark
                small
                elevation="0"
                @click="categoryModal()"
              >
                <v-icon left>mdi-plus</v-icon>Create Category
              </v-btn>
            </v-row>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="6">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.brand_id"
          :items="brands"
          label="Company / Brand"
          item-text="Name"
          item-value="id"
        >
          <template v-if="enableCreate" v-slot:no-data>
            <v-row align="center" justify="center">
              <v-btn
                :loading="searchingProduct"
                class="ma-2"
                color="accent"
                dark
                small
                elevation="0"
                @click="brandModal()"
              >
                <v-icon left>mdi-plus</v-icon>Create Brand
              </v-btn>
            </v-row>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="6">
        <v-text-field
          autocomplete="off"
          type="text"
          hide-details
          outlined
          dense
          label="Buying Price"
          v-model="record.BuyingPrice"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="6">
        <v-text-field
          autocomplete="off"
          type="text"
          hide-details
          outlined
          dense
          label="Selling Price"
          v-model="record.SellingPrice"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="6">
        <v-autocomplete
          autocomplete="off"
          outlined
          dense
          v-model="record.ItemType"
          :items="itemTypes"
          item-text="name"
          item-value="value"
          label="Item Type"
        ></v-autocomplete>
        <span style="color: red">(Only change if not a stock item)</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="6" v-show="docCreate == true">
        <v-text-field
          autocomplete="off"
          type="text"
          hide-details
          outlined
          dense
          label="Re Order Level"
          v-model="record.ReOrder"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="6">
        <v-radio-group dense label="Taxable" v-model="record.Taxable" row>
          <v-radio label="Yes" value="Y"></v-radio>
          <v-radio label="No" value="N"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          outlined
          dense
          label="Barcode(Optional)"
          v-model="record.BarCode"
          type="text"
          autocomplete="off"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          outlined
          dense
          label="Packing i.e pcs/pair"
          v-model="record.Packing"
          type="text"
          autocomplete="off"
        ></v-text-field>
      </v-col>

      <!-- <v-col cols="3">
        <v-text-field dense outlined v-model="record.BuyingPrice" label="Buying Price(custom)"></v-text-field>
      </v-col>-->
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="accent" @click="updateData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <!-- category quick add dialog -->
      <v-dialog v-model="categoryDialog" max-width="650px">
        <v-card>
          <v-toolbar dense color="primary" dark>
            <v-toolbar-title>Create Category</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="categoryDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <category-editor :initial="newItem" @data="saveCategory"></category-editor>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of modal-->

      <!-- brand quick add dialog -->
      <v-dialog v-model="brandDialog" max-width="650px">
        <v-card>
          <v-toolbar dense color="primary" dark>
            <v-toolbar-title>Create Brand</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="brandDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <brand-editor :initial="newItem" @data="saveBrand"></brand-editor>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of modal-->
    </v-row>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
import CategoryEditor from "@/components/subscriber/products/categories/_components/quick-editor.vue";
import BrandEditor from "@/components/subscriber/products/brands/_components/quick-editor.vue";
export default {
  components: {
    CategoryEditor,
    BrandEditor
  },
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    newItem: {},
    categoryDialog: false,
    brandDialog: false,
    enableCreate: true,
    searchingProduct: false,
    loader: false,
    PriceUnit: null,
    categories: [],
    industries: [],
    showPricing: false,
    manualStatus: false,
    uoms: [],
    ougp: [],
    brands: [],
    stores: [],
    store: null,
    date: new Date().toISOString().substr(0, 10),
    itemTypes: [
      { name: "Inventory", value: "I" },
      { name: "Service Item", value: "S" },
      { name: "Delivery Charges", value: "C" }
    ]
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      if (this.docCreate == false) {
        if (val.ugpentry) {
          const manualType = val.ugpentry.IsManual;
          if (manualType == "Y") {
            this.showPricing = false;
            this.manualStatus = true;
          } else {
            this.showPricing = true;
            this.manualStatus = false;
            // get uom group uoms
            const self = this;
            this.$store
              .dispatch("get", `/ougp/${val.UgpEntry}`)
              .then(res => {
                self.uoms = res.ResponseData.groupDef;
              })
              .catch(err => {
                this.$refs.snackbar.show(err, "red");
              });
            // end
          }
        }
      }

      this.record = { ...val };
    },
    categoryModal() {
      this.categoryDialog = true;
    },
    brandModal() {
      this.brandDialog = true;
    },
    saveBrand(data) {
      const url = "/brands";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.brands = [...this.brands, res.ResponseData];
            self.record.brand_id = res.ResponseData.id;
            self.$refs.snackbar.show("Brand Added Successully", "green");
            self.brandDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveCategory(data) {
      const url = "/products-categories";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = [...this.categories, res.ResponseData];
            self.record.i_t_m1_s_id = res.ResponseData.id;
            self.$refs.snackbar.show("Category Added Successully", "green");
            self.$store.commit("btnLoader", false);
            self.categoryDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (this.record.ItemType == null || this.record.ItemType == undefined) {
        this.$refs.snackbar.show("Please select Item Type!", "red");
      } else {
        if (
          this.record.SellingPrice != null ||
          this.record.SellingPrice != undefined
        ) {
          if (
            this.record.BuyingPrice != null ||
            this.record.BuyingPrice != undefined
          ) {
            // this.loader = true;
            if (this.record.SerialStatus == "Y") {
              const customName = `${this.record.productName} - ${this.record.SerialNo}`;
              this.record.Name = customName;
            } else {
              this.record.Name = this.record.productName;
            }

            this.$store.commit("btnLoader", true);
            this.$emit("data", this.record);
          } else {
            this.$refs.snackbar.show("Buying price missing!", "red");
          }
        } else {
          this.$refs.snackbar.show("Selling price missing!", "red");
        }
      }
    },
    updateData() {
      this.loader = true;
      this.$emit("data", this.record);
    },
    setSVolume(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.SVolume = data.BaseQty;
    },
    setSalUnitMsr(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInSale = data.BaseQty;
    },
    setInvntryUom(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInCnt = data.BaseQty;
    },
    setBuyUnitMsr(id) {
      const data = this.uoms.find(record => {
        return record.UomEntry === id;
      });
      this.record.NumInBuy = data.BaseQty;
    },
    CheckUoMGroup(id) {
      const uomGroup = this.ougp.find(record => {
        return record.id === id;
      });
      const self = this;
      if (uomGroup.UgpName === "Manual") {
        self.showPricing = false;
        self.manualStatus = true;
      } else {
        this.loading = true;
        this.$store
          .dispatch("get", `/ougp/${id}`)
          .then(res => {
            self.uoms = res.ResponseData.groupDef;
            self.showPricing = true;
            self.manualStatus = false;
            self.record.SalUnitMsr = null;
            self.loading = false;
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getIndustries() {
      const self = this;
      this.$store
        .dispatch("get", `/industries`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.industries = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOugp() {
      const self = this;
      this.$store
        .dispatch("get", `/ougp`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.ougp = res.ResponseData;
            // self.record = { ...self.record, UgpEntry: res.ResponseData[0].id };
            if (self.docCreate == true) {
              self.record.UgpEntry = res.ResponseData[0].id;
              self.record.NumInBuy = 1;
              self.record.NumInSale = 1;
              self.record.NumInBuy = 1;
              // end
              self.showPricing = false;
              self.manualStatus = true;
            }
            // set items per msr
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGeneralSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            // set default store
            if (self.docCreate == true) {
              self.store = res.ResponseData.store_id;
            }
            // set default category
            if (self.record.i_t_m1_s_id == undefined) {
              const brandId = res.ResponseData.defaultBrand;
              const categoryId = res.ResponseData.defaultCategory;
              self.record = {
                ...self.record,
                i_t_m1_s_id: categoryId,
                brand_id: brandId,
                Taxable: "Y",
                SerialStatus: "N"
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getCategories();
    this.getBrands();
    this.getIndustries();
    this.getStores();
    this.getGeneralSettings();
    this.getOugp();
  }
};
</script>